export default __webpack_public_path__ + "static/media/bm_reps_logo.db3f8477.png";